import * as actionsType from "./actionsType";

export const sortingData = (sortData) => {
  return {
    type: actionsType.SORT_DATA,
    payload: sortData,
  };
};
